<template>
  <div
    v-if="show"
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.root"
  >
    <div :style="style.container">
      <div :style="style.left">
        <slot name="left" />
      </div>
      <div :style="style.center">
        <slot name="center" />
      </div>
      <div :style="style.right">
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseNotification',
    inheritAttrs: false,
    props: {
      show: {
        type: Boolean,
        required: false,
        default: false,
      },
      styleConfig: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        style: {
          center: {},
          container: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          left: {},
          right: {},
          root: {
            position: 'fixed',
            width: '100%',
            zIndex: 9999999,
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.center,
        this.styleConfig.center,
      );
      Object.assign(
        this.style.container,
        this.styleConfig.container,
      );
      Object.assign(
        this.style.left,
        this.styleConfig.left,
      );
      Object.assign(
        this.style.right,
        this.styleConfig.right,
      );
      Object.assign(
        this.style.root,
        this.styleConfig.root,
      );
    },
  };
</script>
